export const SETCUSTOMERLIST = "SETCUSTOMERLIST";
export const SETBRANCHLIST = "SETBRANCHLIST";
export const SETADVANCELIST = "SETADVANCELIST";
export const SETRESETDOC = "SETRESETDOC";
export const SETTYPE = "SETTYPE";
export const SETSBU = "SETSBU";
export const SETDOCNUM = "SETDOCNUM";
export const SETSETTLEMENTLISTINAPPROVAL = "SETSETTLEMENTLISTINAPPROVAL";
export const SETSETTLEMENTATTACHMENTS = "SETSETTLEMENTATTACHMENTS";
export const SETAPPROVALSTATUS = "SETAPPROVALSTATUS";
export const SETSETTLEMENTLISTBASICFILTERDATA = "SETSETTLEMENTLISTBASICFILTERDATA";
export const SETSETTLEMENTBASICFILTERDATA = "SETSETTLEMENTBASICFILTERDATA";





